// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","label":"label-1mq9z","header":"header-Q0u4I","title":"title-2M1eG","paper":"paper-2xlIi","button":"button-3uVwI"};